module.exports = __webpack_public_path__ + "img/45_36.bf90a555.png";